import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';
import { Link } from 'react-router-dom';

export default function FeaturedComics() {
  const featured = comics.slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">精选高分韩漫，不容错过</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部热门 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}